import {setEffectParameterValue} from 'actions/index.js';
import {sleep} from 'utils/sleep.js';

const C = 'C';
const A = 'A';
const B1 = 'B1';
const B2 = 'B2';
const X = 'X';
const Y = 'Y';

export default superclass => class extends superclass  {

    currentAlgo = undefined;

    algorithms = {
        1: {
            A: {
                feedback: true,
                edges: [C]
            },
            B2: {
                edges: [B1]
            },
            B1: {
                edges: [C, Y]
            },
            C: {
                edges: [X]
            }
        },
        2: {
            A: {
                edges: [C],
            },
            B2: {
                edges: [B1],
                feedback: true
            },
            B1: {
                edges: [Y]
            },
            C: {
                edges: [X],
            }
        },
        3: {
            A: {
                edges: [C, B2, B1],
                feedback: true
            },
            B2: {
                edges: [X],
            },
            B1: {
                edges: [Y]
            },
            C: {
                edges: [X],
            }
        },
        4: {
            A: {
                edges: [C],
            },
            B2: {
                edges: [B1],
                feedback: true
            },
            B1: {
                edges: [A, Y]
            },
            C: {
                edges: [X],
            }
        },
        5: {
            A: {
                edges: [C, Y],
            },
            B2: {
                edges: [B1, A],
            },
            B1: {
                edges: [A],
                feedback: true
            },
            C: {
                edges: [X],
            }
        },
        6: {
            A: {
                edges: [C, B1],
                feedback: true
            },
            B2: {
                edges: [C, B1],
            },
            B1: {
                edges: [Y],
            },
            C: {
                edges: [X],
            }
        },
        7: {
            A: {
                edges: [C, X],
                feedback: true
            },
            B2: {
                edges: [B1, Y],
            },
            B1: {
                edges: [Y],
            },
            C: {
                edges: [X],
            }
        },
        8: {
            A: {
                edges: [C],
            },
            B2: {
                edges: [X],
            },
            B1: {
                edges: [Y],
                feedback: true
            },
            C: {
                edges: [X],
            }
        },
        9: {
            A: {
                feedback: true,
                edges: [C]
            },
            B2: {
                edges: [B1, X]
            },
            B1: {
                edges: [C, Y]
            },
            C: {
                edges: [X]
            }
        },
 
    };
    
    changeAlgorithm(algo, xOutput=this.outputNodeX, yOutput=this.outputNodeY, skipDelete=false) {
        if (algo === this.currentAlgo) {
            return;
        }
        let algorithm = this.algorithms[algo];

        if (!skipDelete) {
            this.deleteAlgorithmRouting(undefined, xOutput, yOutput);
        }

        // next hook up this algorithm
        for (let nodeName in algorithm) {
            let nodeAlgo = algorithm[nodeName];
            let fromNode = this.getNodeByName(nodeName, xOutput, yOutput);
            fromNode.feedback = nodeAlgo.feedback;
            for (let toNodeName of nodeAlgo.edges) {
                let toNode = this.getNodeByName(toNodeName, xOutput, yOutput);
                this.connectNodes(fromNode, toNode);
            }

            if (fromNode.feedback) {
                for (let i in fromNode.voices) {
                    let voice = fromNode.voices[i];
                    fromNode.connectFeedbackEdge(fromNode.feedbackEdge, voice, parseInt(i));
                }
                this.feedbackParameter = fromNode.feedbackParameter;
            }
        }
        this.adjacencyLists = {... this.adjacencyLists};
        this.currentAlgo = algo;
        this.refreshAmpEnvelopes();
    }

    deleteAlgorithmRouting(skipFeedback=false) {
        if (!skipFeedback) {
            this.oscillatorNodes.forEach(
                osc => {
                    if (osc.feedback) {
                        osc.voices.forEach((v, i) => osc.feedbackEdge.disconnect(v, i));
                    }
                    osc.feedback = false;
                    if (this.loaded) {
                        osc.feedbackParameter.set(0, true, true);
                    } else {
                    }
                });
        }
        
        // first delete the edges
        for (let effectId in this.adjacencyLists) {
            let edges = [... this.adjacencyLists[effectId]];
            edges.forEach(
                edge => this.deleteEdge(edge));
        }

        this.currentAlgo = -1;
    }

    getNodeByName(name, xOutput, yOutput) {
        if (name === X) {
            return xOutput;
        }

        if (name == Y) {
            return yOutput;
        }
        return this.oscillatorNodes.find(
            osc => osc.name === name);
    }

    async testAlgo() {
        let algo = 1;
        for (let i=0; i < 100; i++) {
            this.algorithmParameter.set(algo, false, false);
            await sleep(200);
            algo++;
            if (algo >= 9) {
                algo = 1;
            }
        }
    }
}
